module.exports = __webpack_public_path__ + "img/bg_avatar_female_19.ed121b4f.png";